<template>
  <!-- this is renderless component that processes pusher updates -->
  <span class="hidden" />
</template>

<script>
import Pusher from 'pusher-js'

export default {
	name: 'PusherVirtualAuctioneer',

	computed: {

		// the pusher settings from the store
		virtualAuctioneerPusherSettings: function () {
			return this.$store.getters.virtualAuctioneerPusherSettings
		}
	},

	created () {
		this.pusherSetup()
	},

	methods: {

		// creates a new pusher listener
		pusherSetup: function() {

			// instantiate the pusher object
			let pusher = new Pusher(this.virtualAuctioneerPusherSettings.channel, { cluster: this.virtualAuctioneerPusherSettings.region })

			// subscribe to the correct pusher channel
			pusher.subscribe('my-channel')

			// a pusher message has arrived
			pusher.bind('my-event', data => {
                // run the process pusher update action in the store on the message we just received
                this.$store.dispatch('processVirtualAuctioneerUpdate', data)
			})
		}
	}
}
</script>
<style>
</style>
